import React from "react";
import QButton from "../../../../common/components/QButton";

export type SettingsPanelField = {
    label: string;
    value: React.ReactNode;
    highlight?: boolean;
    fullWidth?: boolean;
};

type BadgeVariant = "success" | "warning" | "secondary";

type SettingsPanelCardProps = {
    title: string;
    badge?: {
        label: string;
        variant: BadgeVariant;
    };
    help?: string;
    onEdit?: () => void;
    editLabel?: string;
    headerActions?: React.ReactNode;
    fields?: SettingsPanelField[];
    children?: React.ReactNode;
    className?: string;
};

const BADGE_CLASS: Record<BadgeVariant, string> = {
    success: "bg-success",
    warning: "bg-warning text-dark",
    secondary: "bg-secondary",
};

const SettingsPanelCard: React.FC<SettingsPanelCardProps> = ({
    title,
    badge,
    help,
    onEdit,
    editLabel,
    headerActions,
    fields = [],
    children,
    className = "",
}) => (
    <div className={`business-detail bg-orange-bland-zp bdr-20 pd-25 mb-3 ${className}`.trim()}>
        <div className="row align-items-start mb-2">
            <div className="col-md-8">
                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <h2 className="fw-bold fs-24 mb-0">{title}</h2>
                    {badge ? (
                        <span className={`badge ${BADGE_CLASS[badge.variant]}`}>
                            {badge.label}
                        </span>
                    ) : null}
                </div>
                {help ? <p className="text-muted mb-0 small mt-1">{help}</p> : null}
            </div>
            <div className="col-md-4 text-end d-flex align-items-start justify-content-end gap-2 flex-wrap">
                {headerActions}
                {onEdit ? (
                    <QButton
                        type="default"
                        className="btn-sm"
                        onClick={onEdit}
                        content={editLabel}
                    />
                ) : null}
            </div>
        </div>
        {children}
        {fields.length > 0 ? (
            <div className="row">
                {fields.map((field, index) => (
                    <div
                        key={`${field.label}-${index}`}
                        className={`${field.fullWidth ? "col-12" : "col-md-4"} mb-2`}
                    >
                        <b className={field.highlight ? "text-warning" : "text-danger"}>
                            {field.label}:
                        </b>{" "}
                        {field.value ?? "n/a"}
                    </div>
                ))}
            </div>
        ) : null}
    </div>
);

export default React.memo(SettingsPanelCard);
